import { render, staticRenderFns } from "./AdminHome.vue?vue&type=template&id=09d8ba42&scoped=true"
import script from "./AdminHome.vue?vue&type=script&lang=js"
export * from "./AdminHome.vue?vue&type=script&lang=js"
import style0 from "./AdminHome.vue?vue&type=style&index=0&id=09d8ba42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../.npm/_npx/14f5bcddd9f17f34/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d8ba42",
  null
  
)

export default component.exports